import Footer from "../components/Footer";

export default function Privacy() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 p-6">
        <h1 className="text-2xl font-bold">Confidentialité</h1>
        <div className="prose max-w-3xl">
          <p className="text-text">Dernière mise à jour: {new Date().toLocaleDateString()}</p>
          <h2>Données collectées</h2>
          <ul>
            <li>Identifiants de compte (email, nom).</li>
            <li>Données d’usage (pages vues, actions de génération).</li>
            <li>Contenus fournis par l’utilisateur (mots‑clés, articles).</li>
          </ul>
          <h2>Finalités</h2>
          <ul>
            <li>Fourniture du service (authentification, génération, historique).</li>
            <li>Amélioration produit et support.</li>
            <li>Facturation et conformité.</li>
          </ul>
          <h2>Base légale</h2>
          <p>Exécution du contrat et intérêt légitime; consentement pour certaines fonctionnalités optionnelles.</p>
          <h2>Conservation</h2>
          <p>Les données sont conservées tant que le compte est actif, puis supprimées ou anonymisées.</p>
          <h2>Vos droits</h2>
          <p>Accès, rectification, suppression, portabilité, opposition et limitation. Contactez‑nous via la page Contact.</p>
          <h2>Sous‑traitants</h2>
          <p>Hébergement et authentification: Supabase. Génération: OpenAI. Analytics: Cloudflare.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
